import styles from 'styles/RemoveBackgroundScreen.module.css'
import _ from 'lodash'

function RemoveBackgroundScreen() {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        Remove the Background
      </div>
      <div className={styles.button} onClick={()=>window.open('https://www.remove.bg/upload', '_blank')}>
        CLICK HERE
      </div>
    </div>
  )
}

export default RemoveBackgroundScreen
